export interface IModal {
	data: string;
	role?: string;
}
